import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";

function init() {
    setEvents();
}

function setEvents() {
    $("#selectCourseType").change(selectCourseTypeChange);
}

function getQueryStringFilters() {
    const filters = getFilters();
    for (const key in filters) {
        if (!filters[key]) {
            delete filters[key];
        }
    }
    return filters;
}

function selectCourseTypeChange() {
    populateddlCourseLengthId();
}

function populateddlCourseLengthId() {
    const courseTypeId = $("#selectCourseType").val();
    if (courseTypeId === "") {
        initselectCourseLength();
        return;
    }
    dataaccess.get({ url: "/Course/GetCourseLengths/" + courseTypeId }).done(function (results) {
        initselectCourseLength();
        let i;
        for (i = 0; i < results.length; i++) {
            $("#selectCourseLength").append(
                "<option value=" +
                results[i].id +
                " data-schedule-days='" +
                results[i].scheduleDays +
                "'>" +
                results[i].description +
                "</option>"
            );
        }
    });
}

function initselectCourseLength() {
    $("#selectCourseLength")
        .find("option")
        .remove()
        .end()
        .append(
            $("<option />")
                .val("")
                .text("Course Length")
        );
}
function getFilters() {
    return {
        courseTypeId: toIntOrNull($("#selectCourseType").val()),
        courseLengthId: toIntOrNull($("#selectCourseLength").val()),
        courseEditionId: toIntOrNull($("#selectEdition").val()),
        startDate: $("#dateRangeStart").val() || null,
        endDate: $("#dateRangeEnd").val() || null,
        siteId: $("#selectSite").val(),
        courseId: toIntOrNull($("#selectCourse").val())
    };
}
function toIntOrNull(val) {
    const parsed = parseInt(val);
    if (isNaN(parsed)) { return null; }
    return parsed;
}

export const courseEvaluationReportFilters = {
    init: init,
    getFilters: getFilters,
    getQueryStringFilters: getQueryStringFilters
};